import { Injectable } from '@angular/core';
import { BaseNotifier } from '../../../../shared/notifiers/base-notifier';
import { Ref } from '../../../../shared/providers/ref';
import { MapProvider } from '../map/map-provider';
import { FullExtentState } from './full-extent-state';
import * as reactiveUtils from '@arcgis/core/core/reactiveUtils.js';

@Injectable()
export class FullExtentNotifier extends BaseNotifier<FullExtentState> {
  private static readonly INITIAL: FullExtentState = {
    geometry: null,
    homeCenter: [-75.0, -9.0],
    homeZoom: 5,
  };

  constructor(ref: Ref) {
    super(ref, FullExtentNotifier.INITIAL);
  }

  override build(): void {
    const view = this.ref.watch(MapProvider).state().view;
    if (!view) return;
    this.trackHandle(
      reactiveUtils.watch(() => view.extent, (extent: any) => {
        this.updateState(s => ({ ...s, geometry: extent }));
      })
    );
  }

  goHome(): void {
    const view = this.ref.watch(MapProvider).state().view;
    if (!view) return;
    const s = this.snapshot();
    view.goTo({ center: s.homeCenter, zoom: s.homeZoom });
  }

  setGeometry(geometry: any | null): void {
    this.updateState(s => ({ ...s, geometry }));
  }
}
